import React from 'react'

import styles from './SuccessIcon.module.css'

const SuccessIcon = ({ width = 100, height = 100 }) => {
  const iconStyle = {
    width: `${width}px`,
    height: `${height}px`,
    '--icon-width': `${width}px`,
    '--icon-height': `${height}px`,
    '--outer-size': `${width}px`,
    '--inner-size': `${width * 0.84}px`,
    '--checkmark-size': `${width * 0.7}px`
  }

  return (
    <div className={styles.successIcon} style={iconStyle}>
      <div className={styles.circleOuter}></div>
      <div className={styles.circleInner}>
        <div className={styles.checkmark}>
          <svg viewBox="0 0 100 100">
            <path d="M20 50 L40 70 L80 30"></path>
          </svg>
        </div>
      </div>
    </div>
  )
}

export default SuccessIcon
